export function formatAssociationType(value: string | null | undefined): string {
  if (value == null || value === '' || value === '-') {
    return '-';
  }
  if (value.includes(' ') || value.includes('-')) {
    return value;
  }
  return value.replace(/([A-Z])/g, ' $1').trim();
}
